export function sendGoToListingEvent(analyticsPostfix, snippetEncryptedData) {
    try {
        let labelTemp = analyticsObjects.labelElements.detail;
        if (snippetEncryptedData.length > 0) {
            labelTemp += '-' + hex2a(snippetEncryptedData);
        }
        if (typeof analyticsPostfix !== 'undefined') {
            labelTemp += '-' + analyticsPostfix;
        }
        analytics.submitEventAction(awp, analyticsObjects.actions.gotoAction, labelTemp);
    } catch (e) {
    }
}